import { useState } from "react";
import {
  getCurrentCashApi,
  getCashSessionsApi,
  openCashApi,
  addCashMovementApi,
  closeCashApi,
  voidCashMovementApi,
} from "../api/cash";
import { useAuth } from "./";

export function useCash() {
  const { auth } = useAuth();
  const [loading, setLoading] = useState(true);
  const [session, setSession] = useState(null);
  const [sessions, setSessions] = useState(null);

  const getCurrentCash = async () => {
    setLoading(true);
    try {
      setSession(await getCurrentCashApi(auth.token));
    } finally {
      setLoading(false);
    }
  };

  const getCashSessions = async () => {
    setLoading(true);
    try {
      setSessions(await getCashSessionsApi(auth.token));
    } finally {
      setLoading(false);
    }
  };

  // Estas tres lanzan el error (con el mensaje del backend) para que la
  // pantalla lo muestre en un toast.
  const openCash = async (openingAmount) =>
    setSession(await openCashApi(openingAmount, auth.token));

  const addCashMovement = async (movement) =>
    setSession(await addCashMovementApi(session.id, movement, auth.token));

  const voidCashMovement = async (movementId, reason) =>
    setSession(await voidCashMovementApi(session.id, movementId, reason, auth.token));

  const closeCash = async (countedAmount, notes) =>
    closeCashApi(session.id, countedAmount, notes, auth.token);

  return {
    loading,
    session,
    // Para pantallas que reciben la caja actualizada de otra API (propinas).
    setSession,
    sessions,
    getCurrentCash,
    getCashSessions,
    openCash,
    addCashMovement,
    voidCashMovement,
    closeCash,
  };
}
